<template>
  <td>
    <v-chip
      class="mr-2"
      v-for="serviceRequirement in slicedServiceRequirements"
      :key="serviceRequirement.id"
    >{{serviceRequirement.shortName}}</v-chip>
    <v-chip v-if="serviceRequirements.length > displayCount">+ {{serviceRequirements.length - displayCount}}</v-chip>
  </td>
</template>
<script>
export default {
  props: {
    serviceRequirements: { required: true },
  },
  computed: {
    slicedServiceRequirements() {
      return this.serviceRequirements.slice(0, this.displayCount);
    },
  },
  data: () => {
    return {
      displayCount: 10,
    };
  },
};
</script>
